/*
 * @Description: 请求配置
 * @Date: 2020-07-15 17:58:52
 * @LastEditTime: 2021-02-19 17:01:23
 */

import axios from 'axios'
import {
  getToken
} from '@/utils/auth'
import {
  Message
} from 'element-ui'
import store from '../store'


let baseURL = ''
// 测试环境地址
// const TEST_ENV = 'http://192.168.211.151:8000'
// 正式环境地址
// const FORMAl_ENV = 'http://api.prodsass.ufovpn.io/'
let _origin = window.location.origin
if (_origin === 'http://localhost:8000') {
  baseURL = 'http://apiprodsass.bestcaco.com/'
  // baseURL = 'http://tracking.cdzyzs.net/api/'
} else {
  baseURL = _origin
}
console.log(_origin);

// if (process.env.NODE_ENV === 'test') {
//   // 测试环境 
//   // baseURL = 'http://192.168.211.151:8000'
//   baseURL = 'http://apiprodsass.bestcaco.com/'
//   // http://apiprodsass.bestcaco.com/
//   // baseURL = '/api'

// } else if (process.env.NODE_ENV === 'production') {
//   // 正式环境
//   // baseURL = 'http://api.prodsass.ufovpn.io/'
//   baseURL = 'http://apiprodsass.bestcaco.com/'
// }

const service = axios.create({
  baseURL,
  timeout: 1200 * 1000
})

// request 
service.interceptors.request.use(
  config => {
    const hasToken = getToken
    if (hasToken) {
      config.headers.Authorization = 'Bearer ' + getToken()
    }
    return config
  },
  error => {
    console.log(error, 'eoor') // for debug
    return Promise.reject(error)
  }
)

// response
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 20000) {
      // Message({
      //   message: res.message || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //   // to re-login
      //   MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
      //     confirmButtonText: 'Re-Login',
      //     cancelButtonText: 'Cancel',
      //     type: 'warning'
      //   }).then(() => {
      //     store.dispatch('user/resetToken').then(() => {
      //       location.reload()
      //     })
      //   })
      // }
      // return Promise.reject(new Error(res.message || 'Error'))
      return res.payload
    } else {
      return res.payload
    }
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    if (error.response.status === 401) {
      console.log('401 --->');
      // redirect login

      store.dispatch('user/logout').then(() => {
        setTimeout(() => {
          location.reload()
        }, 1000)
      })
    }
    return Promise.reject(error)
  }
)

export default service